import { ApiRequestInterceptor } from "./apiRequestAws";
import { CHAT } from "../constants/endpoints/endpoints";

export const fetchChatbot = async (text) => {
  const method = "POST";
  const body = { text }; // el payload que tu Lambda espera

  const response = await ApiRequestInterceptor(CHAT.chat, method, body);
  const { code, data } = response;

  if (code === 200) {
    return { code, data };
  } else {
    throw new Error("Error al obtener respuesta del chatbot");
  }
};